import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCGhbGell70Dbe_MCTkO9PXXH_QnhvZj4g",
  authDomain: "havana-group-operations-31b4d.firebaseapp.com",
  projectId: "havana-group-operations-31b4d",
  storageBucket: "havana-group-operations-31b4d.firebasestorage.app",
  messagingSenderId: "1061564084397",
  appId: "1:1061564084397:web:ae479c65e67b3b7a5e1624",
  measurementId: "G-NLWFTZ7X2H"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  databaseId: "CHECK_IF_CODE_IS_RELOADING"
});

export default app;